import React from 'react';
import { get, has } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css `
  width: 100%;
  max-width: 335px;
  margin: 0 0 40px;
  @media(min-width: 576px) {
    margin: 5px;
  }
  @media(min-width: 992px) {
    max-width: 450px;
    margin: 10px;
  }
  @media(min-width: 1350px) {
    margin: 15px;
    max-width: 572px;
  }

  .Blogpost_image {
    display: block;
    width: 100%;
    height: 191px;
    margin-bottom: 8px;
    background-size: cover;
    background-position: center center;
    @media (min-width: 768px) {
      overflow: hidden;
      position: relative;
      height: 235px;
      margin-bottom: 9.5px;
    }
    @media (min-width: 992px) {
      height: 301px;
      margin-bottom: 11px;
    }
  }
  .Blogcard_image {
    @media (min-width: 768px) {
      position: absolute;
      top: -100%;
      right: -100%;
      bottom: -100%;
      left: -100%;
      margin: auto;
      min-height: 100%;
      @supports (object-fit: cover) {
        position: static;
        height: 100%;
        min-height: 0;
        margin: 0;
        object-fit: cover;
      }
    }
  }
  .Blogpost_content{
    background-color: #FFF;
  }
  .blogpost_date {
    color: ${colors.text};
    font-weight: 300;
    font-size: 13px;
    line-height: 18px;
    @media (min-width: 768px) {
      font-size: 15px;
      line-height: 22px;
    }
  }
  .Blogpost_title {
    color: ${colors.color3};
    font-weight: bold;
    font-size: 17px;
    line-height: 20px;
    transition: all .3s ease-out;
    position: relative;
    padding: 0 0 20px;
    margin: 0 0 10px;
    @media (min-width: 768px) {
      padding: 0 0 30px;
      margin: 0 0 15px;
      font-size: 22px;
      line-height: 30px;
      letter-spacing: 1px;
    }
    &::after {
      content: "";
      width: 75px;
      height: 2px;
      background-color: ${colors.color1};
      position: absolute;
      left: 0;
      bottom: 0;
      @media(min-width: 992px) {
        width: 100px;
        height: 3px;
      }
    }
  }
  .Dog {
      content: "";
      position: relative;
      left: 0;
      bottom: -31px;
      @margin(min-width: 992px) {
        bottom -22px;
      }
  }
  .Blogpost_wrapper{
    transition: all .3s ease-out;
    &:hover{
      opacity: 0.9;
    }
  }
`;

function Blogcard({ blogpost, className }) {
  const blogTitle = get(blogpost, 'title');
  return (
    <section className={`${className} ${styles}`} >
      <Link name="blogpost-detail" params={{ blogpostTitle: blogTitle }} >
        <div className="Blogpost_wrapper" >
          <div className="Blogpost_image" style={{ backgroundImage: `url(${buildThumbnailUrl(blogpost.logo.contentUrl, { width: 1000, height: 1000 })})` }} />
          <div className="Blogpost_content position-relative">
            <div className="blogpost_date" >
              {
                has(blogpost, 'date') &&
                moment(get(blogpost, 'date')).format('MMMM D, YYYY')
              }
            </div>
            <div className="Blogpost_title" >
              {blogpost.title}
            </div>
          </div>
        </div>
      </Link>
    </section>
  );
}

Blogcard.propTypes = {
  blogpost: PropTypes.object.isRequired,
  className: PropTypes.string,
};

Blogcard.defaultProps = {
  className: '',
};


export default Blogcard;



// WEBPACK FOOTER //
// ./src/components/BlogCard.js